import React from "react";
import { render } from "@react-pdf/renderer";
import Paper from '@material-ui/core/Paper';
import { useNavigate } from 'react-router-dom';
import BallotIcon from '@material-ui/icons/Ballot';
import { ReactComponent as FireHoseIcon } from '../../../assets/fire-hose.svg';
import Constants from "../../../utils/Constants";
import { hasUserRole } from "../../../utils/AuthUtils"

const SectionSelect = ({title, route, children}) => {
  const paperStyles = {
    "backgroundColor": "#4267B2",
    "color": "white",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "padding": "2em",
    "margin": ".5em",
    "cursor": "pointer",
    "width": "6em",
    "height": "6em"
  };

  const iconStyles = {
    "fontSize": "5em"
  }
 

  return (
    <Paper square={false} elevation={3} style={paperStyles} onClick={ (e) => { route(); } }>
      { React.cloneElement(children, { style: iconStyles }) }
      { title }
    </Paper>
  );
}

const TestSvgIcon = ({ size = 24, color = "currentColor", ...props }) => {
  return (
 <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    {...props}
  >
    <path
      d="M72.434 200.31h25.587l3.198 3.198v169.51l-3.198 3.198H72.434l-3.198-3.198v-169.51l3.198-3.198Z"
      style={{
        stroke: "#000",
        strokeWidth: 10,
        fill: "#fff",
      }}
    />
    <ellipse
      cx={185.975}
      cy={204.575}
      rx={117.271}
      ry={116.205}
      style={{
        stroke: "#000",
        strokeWidth: 10,
        fill: "#fff",
      }}
    />
    <ellipse
      cx={185.974}
      cy={201.909}
      rx={52.772}
      ry={50.64}
      style={{
        strokeWidth: 10,
        fill: "none",
        stroke: "#000",
      }}
    />
    <ellipse
      cx={184.907}
      cy={202.441}
      rx={83.689}
      ry={84.222}
      style={{
        stroke: "#000",
        fill: "none",
        strokeWidth: 10,
      }}
    />
    <path
      d="M284.789 35.714h23.455l3.198 3.198v169.51l-3.198 3.198h-23.455l-3.198-3.198V38.912l3.198-3.198Z"
      style={{
        stroke: "#000",
        strokeWidth: 10,
        paintOrder: "fill",
        fill: "#fff",
        transformOrigin: "296.516px 123.667px 0",
      }}
      transform="rotate(-90 -21.948 1.708)"
    />
    <path
      d="M362.588 75.731h22.815v57.038h-22.815z"
      style={{
        stroke: "#000",
        strokeWidth: 10,
        strokeLinejoin: "round",
        fill: "#fff",
      }}
    />
    <path
      d="M372.197 130.477h22.815v57.038h-22.815z"
      style={{
        stroke: "#000",
        strokeWidth: 10,
        strokeLinejoin: "round",
        transformOrigin: "383.604px 158.996px 0",
        fill: "#fff",
      }}
      transform="rotate(90 -263.571 -35.029)"
    />
    <path
      d="m387.304 83.337 61.791 9.506v23.766l-61.791 10.457z"
      style={{
        stroke: "#000",
        strokeWidth: 10,
        fill: "#fff",
      }}
    />
    <path
      d="M97.213 121.92h16.051v19.963H97.213z"
      style={{
        fill: "#fff",
      }}
      transform="matrix(1 0 -.00219 1 81.918 -28.459)"
    />
    <ellipse
      cx={185.957}
      cy={205.108}
      rx={13.477}
      ry={13.213}
      style={{
        stroke: "#000",
        fill: "none",
        strokeWidth: 10,
      }}
    />
  </svg>
  );
};

const LandingPage = function(props) {
  const navigate = useNavigate();

  // Check users Roles to see which options are visible.
  const isInventoryActive = hasUserRole(Constants.UserRole.InventoryUser) || hasUserRole(Constants.UserRole.InventoryManager);
  const isHoseActive = hasUserRole(Constants.UserRole.HoseUser) || hasUserRole(Constants.UserRole.HoseManager);

  const render = () => {
    
    const jsxInventory = (
      <SectionSelect title="Inventory" route={() => { navigate(Constants.RoutePath.Inventory.List); } }>
        <BallotIcon />
      </SectionSelect>
    );

    const jsxHoseManagement = (
      <SectionSelect title="Hose" route={() => { navigate(Constants.RoutePath.HoseManagement.Listing); } }>
        <FireHoseIcon fill="#fff" width="80px"/>
      </SectionSelect>
    );

    return (
      <div>

        <div style={{"marginTop": "2em", "display": "flex", "justifyContent": "center", "flexWrap": "wrap"}}>
          { isInventoryActive ? jsxInventory : null }          
          { isHoseActive ? jsxHoseManagement : null }
          
        </div>
      </div>
    );  
  }

  return render();
}

export default LandingPage; 
